import { Component } from '@angular/core';
import { NgoService } from '../../../services/ngo/ngo.service';
import { CreationTypeEnum } from '../../../enum/creation-type.enum';
import { TagCsrService } from '../../../services/tag-csr/tag-csr.service';
import { TagTypeEnum } from '../../../enum/tagCsrEnum.enum';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import { ExternalCsrCampaignDonationModel } from '../../../model/csr/external-csr-donation.model';
import { FileService } from 'src/app/shared/services/file/file.service';
import { forkJoin, switchMap } from 'rxjs';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import validationEngine from 'devextreme/ui/validation_engine';
import { DonationFromStatusTypeEnum } from 'src/app/shared/enum/donation-from-status-type.enum';
import { CorporateCsrService } from 'src/app/shared/services/corporate/corporate-csr/corporate-csr.service';
import { NgoCampaignService } from 'src/app/shared/services/ngo-campaign/ngo-campaign.service';
import { TagCsrModel } from 'src/app/shared/model/csr/tag-csr.model';
@Component({
  selector: 'app-csr-tagged-campaigns',
  templateUrl: './csr-tagged-campaigns.component.html',
  styleUrl: './csr-tagged-campaigns.component.scss',
})
export class CsrTaggedCampaignsComponent {
  public suggestedFund: any = [
    { amount: 200, isSelected: false },
    { amount: 500, isSelected: false },
    { amount: 1000, isSelected: false },
    { amount: 10000, isSelected: false },
    { amount: 20000, isSelected: false },
    { amount: 50000, isSelected: false },
  ];

  public initialSuggestedFund = [...this.suggestedFund];

  public creationTypeEnum = CreationTypeEnum;
  public searchKeyword = '';
  public activeTab: number = 1;

  public donationPopup = false;

  public selectedAmount: number = 10;

  public externalCsrDonationCampaignModel: ExternalCsrCampaignDonationModel =
    new ExternalCsrCampaignDonationModel();

  public tagCsrModel: TagCsrModel = new TagCsrModel();

  public campaignTitle: string = null;

  public openThankYouPopup: boolean = false;

  public url = '';

  public coverFees: boolean = true;
  public sessionUser: any;
  public selectedRole: any;
  private companyId: string = null;
  public activeList: any[] = [];

  public mappingValue: any = null;
  public mapRequest: any = null;
  public receiptFile: any;
  public receiptName: string;
  public matchedAmount: any;
  public hasMatched: boolean = false;
  public searchText: any = '';
  public campaignList: any[] = [];
  public size: number = 6;
  public page: number = 1;
  private totalCampaigns: number = 0;
  public isShowMoreDisabled: boolean = false;
  public csrMatchedCampaignList: any[];
  public csrNotMatchedCampaignList: any[];
  public selectedId: string;

  constructor(
    private readonly ngoService: NgoService,
    private readonly tagCsrService: TagCsrService,
    private readonly localStorageService: LocalStorageService,
    private readonly router: Router,
    private readonly csrService: TagCsrService,
    private readonly fileService: FileService,
    private readonly utilitiesService: UtilitiesService,
    private readonly corporateCsrService: CorporateCsrService,
    private readonly ngoCampaignService: NgoCampaignService
  ) {}

  ngOnInit() {
    this.sessionUser = this.localStorageService.getSessionUser();
    this.selectedRole = this.localStorageService.getSelectedRole();
    this.companyId = this.sessionUser.company_id;
    if (this.selectedRole?.short_form === 'system_admin') {
      this.getAllTaggedCampaigns();
      this.getAllCampaigns(1, 6);
    } else {
      this.mapCsrListAndMatching();
    }
    // if (this.sessionUser?.role?.short_form === 'corporate_admin') {
    //   this.getMappingPercentage();
    // }
  }

  public getAllCampaigns(page: number, size: number): void {
    this.page = page;
    this.size = size;

    this.ngoCampaignService.getAllNgoDonationCampaign(page, size).subscribe({
      next: (result: any) => {
        this.onSuccess(result);
      },
      error: (error: any) => {
        this.onError(`${error.message}`, `${error.name}`);
      },
    });
  }

  public async tagCsr(campaign: any) {
    this.tagCsrModel.ngo_campaign_id = campaign?.id;
    this.tagCsrModel.campaign_title = campaign?.title;
    this.tagCsrModel.name = campaign?.title;
    this.tagCsrModel.type = TagTypeEnum.CAMPAIGN;
    this.tagCsrModel.ngo_id = campaign?.ngo_id;
    this.tagCsrModel.ngo_name = campaign?.ngo_name;
    this.tagCsrModel.project_id = campaign?.project_id;
    this.selectedId = campaign?.id;

    const response = await this.utilitiesService.showSwalAndReturn({
      title: 'Tag this Campaign?',
      type: 'warning',
      confirmButtonText: 'Continue',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
    });
    if (response?.isConfirmed) {
      this.tagCsrService.tagCampaignNgo(this.tagCsrModel).subscribe({
        next: (result: any) => {
          this.tagCsrModel = new TagCsrModel();
          campaign.is_csr_allowed = true;
          // const matchedItemIndex = this.campaignList.findIndex(
          //   (item) => item.id === this.selectedId
          // );

          // if (matchedItemIndex !== -1) {
          //   const [matchedItem] = this.campaignList.splice(matchedItemIndex, 1);
          //   this.activeDataSource.push(matchedItem);
          // }

          const matchedItem = this.campaignList.find(
            (item) => item.id === this.selectedId
          );

          if (matchedItem) {
            this.campaignList.push(matchedItem);
          }

          this.utilitiesService.showSwalWithToast(
            'Success',
            'Campaign tagged successfully',
            'success'
          );
        },
      });
    }
  }

  public async untagCsr(ngo: any) {
    const response = await this.utilitiesService.showSwalAndReturn({
      title: 'Untag this Campaign?',
      type: 'warning',
      confirmButtonText: 'Continue',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
    });

    if (response?.isConfirmed) {
      this.tagCsrService.untagCsrNgoNpo(ngo?.id).subscribe({
        next: (result: any) => {
          ngo.is_csr_allowed = false;

          const matchedItemIndex = this.campaignList.findIndex(
            (item) => item.id === ngo?.id
          );

          // if (matchedItemIndex !== -1) {
          //   const [matchedItem] = this.campaignList.splice(matchedItemIndex, 1);
          // }
        },
      });
    }
  }

  private onSuccess(res: any) {
    const transformedCampaigns = res.data;

    if (this.page === 1) {
      this.campaignList = transformedCampaigns;

      this.page = this.page + 1;
    } else {
      this.campaignList.push(...transformedCampaigns);
    }
    this.totalCampaigns = res.total;
    if (this.totalCampaigns <= this.campaignList.length) {
      this.isShowMoreDisabled = true;
    }
  }

  private onError(errorMessage: string, title: string): void {
    this.utilitiesService.showSwalWithToast(
      `${title}`,
      `${errorMessage} , Something went wrong `,
      'error'
    );
  }

  private mapCsrListAndMatching(): void {
    forkJoin([
      this.corporateCsrService.getAllCsrCampaigns(),
      this.corporateCsrService.getCsrCampaignsByCompany(this.companyId),
    ]).subscribe({
      next: ([campaignList, matchingList]: [any[], any[]]) => {
        const matchingMap = new Map(
          matchingList.map((item) => [item.ngo_campaign_id, item])
        );

        this.activeList = campaignList
          .map((item) => {
            const match = matchingMap.get(item.ngo_campaign_id);

            return {
              ...item,
              has_matching: !!match,
              ...(match
                ? {
                    matching_amount: match.matching_amount,
                    matching_percentage: match.matching_percentage,
                    matching_limit: match.matching_limit,
                    matching_budget: match.matching_budget,
                  }
                : {}),
            };
          })
          .sort((a, b) => a.title.localeCompare(b.title));

        this.csrMatchedCampaignList = this.activeList.filter(
          (item) => item.has_matching
        );

        this.csrNotMatchedCampaignList = this.activeList.filter(
          (item) => !item.has_matching
        );
      },
    });
  }

  public get activeDataSource(): any[] {
    if (!this.searchKeyword) {
      return this.activeList;
    } else {
      return this.activeList.filter((campaign) =>
        campaign.name.toLowerCase().includes(this.searchKeyword)
      );
    }
  }

  private getAllTaggedCampaigns() {
    this.tagCsrService.getAllTaggedNgoCampaigns().subscribe({
      next: (result) => {
        this.activeList = result
          .filter((ngo) => ngo.type === TagTypeEnum.CAMPAIGN)
          .sort((a, b) => a.title.localeCompare(b.title));
      },
    });
  }

  public onSearchKeywordChanged(event: any) {
    this.searchKeyword = event.event.target.value.toLowerCase();
  }

  public goToCampaignDetails(campaign: any): void {
    const queryParams = {
      ngo_id: campaign?.ngo_id,
      project_id: campaign?.project_id,
      id: campaign?.ngo_campaign_id || campaign?.id,
    };
    const router =
      this.selectedRole?.short_form === 'system_admin'
        ? '/admin/campaign'
        : '/employee/campaign';

    this.router.navigate([router], {
      queryParams: {
        data: this.localStorageService.encryptObjectUrl(queryParams),
      },
    });
  }

  public makeDonation(): void {
    this.fileService
      .uploadSingleFile(this.receiptFile)
      .pipe(
        switchMap((fileResponse) => {
          this.externalCsrDonationCampaignModel.payment_receipt =
            this.utilitiesService.jsonStringify(fileResponse[0]);

          return this.tagCsrService.tagCsrCampaignDonation(
            this.externalCsrDonationCampaignModel
          );
        })
      )
      .subscribe((result: any) => {
        this.donationPopup = false;
        this.openThankYouPopup = true;

        this.externalCsrDonationCampaignModel =
          new ExternalCsrCampaignDonationModel();
        validationEngine.resetGroup('validationGrp');
        this.resetSuggestedFund();
      });
  }

  public hide() {
    this.donationPopup = false;
    this.externalCsrDonationCampaignModel =
      new ExternalCsrCampaignDonationModel();
    validationEngine.resetGroup('validationGrp');
    this.resetSuggestedFund();
  }

  private resetSuggestedFund(): void {
    this.suggestedFund = this.initialSuggestedFund.map((item) => ({
      ...item,
      isSelected: false,
    }));
    this.selectedAmount = 10;
  }

  public selectAmount(index: number): void {
    this.suggestedFund.forEach((item) => (item.isSelected = false));
    this.suggestedFund[index].isSelected = true;
    this.selectedAmount = this.suggestedFund[index].amount;
  }

  public donate(): void {
    const { isValid } = validationEngine.validateGroup('validationGrp');

    if (isValid) {
      this.externalCsrDonationCampaignModel.pledged_amount = this.coverFees
        ? this.selectedAmount
        : this.selectedAmount - this.selectedAmount * 0.14;
      this.externalCsrDonationCampaignModel.transaction_fees =
        this.selectedAmount * 0.14;
      this.externalCsrDonationCampaignModel.company_name =
        this.localStorageService.getSessionUser().company_name;
      this.externalCsrDonationCampaignModel.company_id =
        this.localStorageService.getSessionUser().company_id;
      this.externalCsrDonationCampaignModel.user_id = this.sessionUser.id;
      this.externalCsrDonationCampaignModel.matching_request = this.mapRequest;

      if (this.externalCsrDonationCampaignModel.matching_request === null) {
        delete this.externalCsrDonationCampaignModel.matching_request;
      }
      this.makeDonation();
    }
  }

  public donationPopupOpen(campaign: any): void {
    this.campaignTitle = campaign?.title;
    this.externalCsrDonationCampaignModel.campaign_title = campaign.title;
    this.externalCsrDonationCampaignModel.campaign_id =
      campaign.ngo_campaign_id;
    this.externalCsrDonationCampaignModel.ngo_id = campaign.ngo_id;
    this.externalCsrDonationCampaignModel.name = this.sessionUser.name;
    this.externalCsrDonationCampaignModel.email = this.sessionUser.email;
    this.externalCsrDonationCampaignModel.is_direct_donation = false;
    this.externalCsrDonationCampaignModel.ngo_name = campaign.ngo_name;
    (this.externalCsrDonationCampaignModel.donation_from =
      DonationFromStatusTypeEnum.DONATION),
      (this.matchedAmount = campaign?.matching_percentage);
    this.hasMatched = campaign?.has_matching;
    this.donationPopup = true;
  }

  public openPaymentReceiptPopup() {
    this.openThankYouPopup = false;
  }

  public triggerFileInput(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  public onFileChange(e: any): void {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.receiptFile = input.files[0];
      this.receiptName = input.files[0].name;
    }
  }

  public onDropSuccess(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files.length > 0) {
      this.onFileChange({ event: { target: { files: files } } });
    }
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    const items = event.dataTransfer?.items;
    if (items) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }
}
